import React from 'react';
import Hero from './Hero';
import WanGenerator from './WanGenerator';
import Examples from './Examples';
import Features from './Features';
import Steps from './Steps';
import FAQ from './FAQ';
import './Wan.scss';

export default function Wan() {
  return (
    <div className="wan-page">
      <Hero />
      <WanGenerator />
      <Examples />
      <Features />
      <Steps />
      <FAQ />
    </div>
  );
}